var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRightMonth(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 160,
    height: 348,
    viewBox: "0 0 160 348",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M275.017 137.444C289.187 165.828 282.69 205.459 275.31 236.314C268.169 266.173 242.196 275.255 217.79 293.879C191.39 314.025 174.122 343.58 142.751 332.687C112.701 322.252 143.816 276.017 128.755 247.998C115.757 223.815 61.958 210.259 62.1844 182.805C62.4699 148.186 60.1029 86.9504 86.7123 64.8031C115.278 41.0279 151.313 95.1995 187.167 104.981C221.384 114.316 259.176 105.71 275.017 137.444Z",
    fill: "#C4C4C4",
    fillOpacity: 0.02,
    stroke: "#01316E",
    strokeOpacity: 0.05
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M266.528 144.723C279.302 170.312 273.446 206.039 266.794 233.855C260.356 260.773 236.942 268.959 214.94 285.749C191.141 303.91 175.575 330.555 147.293 320.733C120.204 311.326 148.253 269.645 134.676 244.386C122.957 222.585 74.4578 210.363 74.6616 185.613C74.9185 154.404 72.7838 99.1999 96.7717 79.2343C122.523 57.8013 155.009 106.638 187.332 115.457C218.178 123.873 252.247 116.115 266.528 144.723Z",
    fill: "#C4C4C4",
    fillOpacity: 0.02,
    stroke: "#01316E",
    strokeOpacity: 0.05
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M260.763 149.331C272.574 172.988 267.163 206.015 261.015 231.729C255.067 256.613 233.424 264.179 213.087 279.699C191.088 296.486 176.701 321.116 150.558 312.035C125.516 303.336 151.442 264.807 138.889 241.455C128.055 221.3 83.2218 209.998 83.4083 187.118C83.6436 158.267 81.6662 107.233 103.839 88.7778C127.641 68.966 157.674 114.115 187.554 122.27C216.068 130.053 247.56 122.883 260.763 149.331Z",
    fill: "#C4C4C4",
    fillOpacity: 0.02,
    stroke: "#01316E",
    strokeOpacity: 0.05
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M252.468 154.52C262.565 174.741 257.955 202.963 252.714 224.935C247.642 246.197 229.157 252.656 211.79 265.91C193.005 280.248 180.724 301.29 158.389 293.52C136.994 286.077 159.125 253.161 148.394 233.2C139.131 215.973 100.83 206.297 100.98 186.745C101.17 162.09 99.462 118.478 118.395 102.715C138.72 85.7932 164.393 124.387 189.919 131.368C214.28 138.029 241.179 131.914 252.468 154.52Z",
    fill: "#C4C4C4",
    fillOpacity: 0.02,
    stroke: "#01316E",
    strokeOpacity: 0.05
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M248.34 160.903C257.535 179.322 253.318 205.039 248.529 225.061C243.895 244.437 227.041 250.33 211.203 262.416C194.071 275.489 182.866 294.668 162.509 287.599C143.009 280.828 163.201 250.825 153.427 232.644C144.992 216.952 110.082 208.155 110.229 190.34C110.414 167.875 108.879 128.139 126.146 113.767C144.683 98.3385 168.066 133.491 191.333 139.838C213.537 145.896 238.06 140.311 248.34 160.903Z",
    fill: "#C4C4C4",
    fillOpacity: 0.02,
    stroke: "#01316E",
    strokeOpacity: 0.05
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M241.073 166.948C249.089 183.006 245.407 205.43 241.228 222.888C237.183 239.782 222.485 244.924 208.671 255.464C193.729 266.865 183.955 283.589 166.203 277.429C149.2 271.529 166.813 245.366 158.293 229.515C150.94 215.834 120.497 208.17 120.629 192.637C120.794 173.05 119.462 138.404 134.522 125.87C150.689 112.415 171.075 143.061 191.364 148.591C210.726 153.869 232.112 148.996 241.073 166.948Z",
    fill: "#C4C4C4",
    fillOpacity: 0.02,
    stroke: "#01316E",
    strokeOpacity: 0.05
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M237.745 171.564C245.052 186.206 241.692 206.653 237.878 222.573C234.188 237.979 220.782 242.669 208.184 252.282C194.556 262.68 185.639 277.931 169.451 272.317C153.945 266.938 170.011 243.079 162.244 228.627C155.539 216.153 127.778 209.169 127.9 195.005C128.053 177.144 126.842 145.552 140.579 134.122C155.325 121.851 173.912 149.792 192.414 154.832C210.07 159.642 229.575 155.196 237.745 171.564Z",
    fill: "#C4C4C4",
    fillOpacity: 0.02,
    stroke: "#01316E",
    strokeOpacity: 0.05
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M225.349 183.949C230.493 194.254 228.131 208.643 225.449 219.846C222.854 230.687 213.421 233.986 204.557 240.75C194.969 248.066 188.697 258.798 177.306 254.845C166.395 251.058 177.697 234.269 172.23 224.098C167.511 215.319 147.976 210.4 148.06 200.433C148.166 187.864 147.311 165.631 156.975 157.588C167.349 148.954 181.88 159.581 194.899 163.13C207.324 166.517 219.599 172.429 225.349 183.949Z",
    fill: "#C4C4C4",
    fillOpacity: 0.02,
    stroke: "#01316E",
    strokeOpacity: 0.05
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M219.37 189.092C223.508 197.375 221.631 208.928 219.494 217.923C217.426 226.626 211.244 231.545 202.764 234.686C199.851 235.035 199.488 235.27 195.111 233.743C186.355 230.689 181.212 229.448 176.815 221.272C173.02 214.216 157.346 210.242 157.401 202.236C157.471 192.142 156.757 174.285 164.499 167.837C172.809 160.916 184.476 169.469 194.922 172.335C204.892 175.07 214.744 179.833 219.37 189.092Z",
    fill: "#C4C4C4",
    fillOpacity: 0.02,
    stroke: "#01316E",
    strokeOpacity: 0.05
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M211.568 192.028C214.637 198.153 213.298 206.671 211.759 213.299C210.269 219.713 205.745 223.32 199.525 225.608C197.387 225.856 197.121 226.029 193.9 224.887C187.456 222.603 183.674 221.67 180.415 215.623C177.602 210.403 166.073 207.417 166.086 201.511C166.102 194.064 165.516 180.887 171.181 176.157C177.262 171.079 185.864 177.43 193.549 179.58C200.882 181.633 208.137 185.181 211.568 192.028Z",
    fill: "#C4C4C4",
    fillOpacity: 0.02,
    stroke: "#01316E",
    strokeOpacity: 0.05
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightMonth);
export default __webpack_public_path__ + "static/media/Right-Month.8ce22ca34409885b278cf32ecb4b0b39.svg";
export { ForwardRef as ReactComponent };